import { onBeforeUnmount, onMounted, ref, type Ref } from "vue";

/** Content-box width of an element in CSS pixels, kept current as the layout changes. */
export function useElementWidth(target: Ref<HTMLElement | null>): Ref<number> {
  const width = ref(0);
  let observer: ResizeObserver | null = null;

  onMounted(() => {
    const element = target.value;
    if (!element) return;
    width.value = element.clientWidth;
    observer = new ResizeObserver((entries) => {
      const next = Math.round(entries[0]?.contentRect.width ?? element.clientWidth);
      if (next !== width.value) width.value = next;
    });
    observer.observe(element);
  });

  onBeforeUnmount(() => observer?.disconnect());
  return width;
}
